if (!window.ProductSliderThumbnails) {
  /**
   *  @class
   *  @function ProductSliderThumbnails
   */
  window.ProductSliderThumbnails = class ProductSliderThumbnails extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container ? this.thumbnail_container.querySelectorAll('.product-thumbnail') : [];
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.has_custom_arrows = !!(this.prev_button && this.next_button);
      const navigation_dots = this.dataset.navigationDots === 'true';
      const show_navigation_desktop = this.dataset.showNavigationDesktop === 'true';
      const show_navigation_mobile = this.dataset.showNavigationMobile === 'true';
      const has_multiple_slides = this.dataset.hasMultipleSlides === 'true';
      const show_page_dots = (show_navigation_desktop || show_navigation_mobile) && has_multiple_slides && navigation_dots;
      this.options = {
        wrapAround: true,
        pageDots: show_page_dots,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: !this.has_custom_arrows,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;
      this.setActiveThumb(this.selectedIndex);

      // Setup Events
      this.setupEvents();

      // Navigation dots visibility (desktop/mobile)
      const navigation_dots = this.dataset.navigationDots === 'true';
      const show_navigation_desktop = this.dataset.showNavigationDesktop === 'true';
      const show_navigation_mobile = this.dataset.showNavigationMobile === 'true';
      if (navigation_dots && (show_navigation_desktop || show_navigation_mobile)) {
        const page_dots = this.querySelector('.flickity-page-dots');
        if (page_dots) {
          if (!show_navigation_desktop) page_dots.classList.add('large-up-hide');
          if (!show_navigation_mobile) page_dots.classList.add('medium-hide', 'small-hide');
        }
      }

      // Progress bar
      const progress_bar = this.parentNode ? this.parentNode.querySelector('.flickity-progress--bar') : null;
      if (progress_bar) {
        this.flkty.on('scroll', function(progress) {
          progress = Math.max(0, Math.min(1, progress));
          progress_bar.style.width = progress * 100 + '%';
        });
      }

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (!this._arrows_bound) {
        if (this.prev_button) {
          let prev = this.prev_button.cloneNode(true);
          this.prev_button.parentNode.append(prev);
          this.prev_button.remove();
          prev.addEventListener('click', (event) => {
            this.flkty.previous();
          });
          prev.addEventListener('keyup', (event) => {
            this.flkty.previous();
            event.preventDefault();
          });
        }
        if (this.next_button) {
          let next = this.next_button.cloneNode(true);
          this.next_button.parentNode.append(next);
          this.next_button.remove();
          next.addEventListener('click', (event) => {
            this.flkty.next();
          });
          next.addEventListener('keyup', (event) => {
            this.flkty.next();
            event.preventDefault();
          });
        }
        this._arrows_bound = true;
      }
      if (this._videoClickController) {
        this._videoClickController.abort();
      }
      this._videoClickController = new AbortController();

      this.video_containers.forEach((container) => {
        const button = container.querySelector('button');
        if (!button) return;
        button.addEventListener('click', function () {
          container.setAttribute('hidden', '');
        }, { signal: this._videoClickController.signal });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          active_thumb = this.setActiveThumb(index);

        if (!active_thumb) return;

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      if (this._thumbClickController) {
        this._thumbClickController.abort();
      }
      this._thumbClickController = new AbortController();
      const signal = this._thumbClickController.signal;

      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail);
          }, { signal });
        });
      });

    }
    setActiveThumb(index) {
      const selected_slide = this.flkty.cells[index] ? this.flkty.cells[index].element : null;
      const thumb_id = selected_slide && selected_slide.id ? selected_slide.id.replace(/^Slide-/, 'Thumb-') : null;
      let active_thumb = thumb_id && this.thumbnail_container ? this.thumbnail_container.querySelector(`[id="${thumb_id}"]`) : null;

      if (!active_thumb) {
        const active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active'));
        active_thumb = active_thumbs[index] || active_thumbs[0];
      }

      if (!active_thumb) return null;

      this.thumbnails.forEach((item) => {
        item.classList.remove('is-initial-selected');
      });
      active_thumb.classList.add('is-initial-selected');

      return active_thumb;
    }
    thumbnailClick(thumbnail) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      // Derive the slide selector from the thumb ID (Thumb-X-Y -> #Slide-X-Y)
      const thumbId = thumbnail.id;
      if (thumbId) {
        const slideSelector = '#' + thumbId.replace(/^Thumb-/, 'Slide-');
        this.flkty.selectCell(slideSelector);
      } else {
        // Fallback: find positional index among active thumbs
        const active_thumbs = Array.from(this.thumbnails).filter(el => el.clientWidth > 0);
        this.flkty.select(active_thumbs.indexOf(thumbnail));
      }
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId, isWrapped, isInstant) {
      this.flkty.selectCell(mediaId, isWrapped, isInstant);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item, index) => {
        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider-thumbnails', ProductSliderThumbnails);
}